import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import "./navigationBar.css"




 
const NavigatorBar = (props) => {

    const [steps, setSteps] = useState({
        first: true,
        secund: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false
    })

useEffect(()=>{
   if(props.steps == 1){
    setSteps({
        first: true,
        secund: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false

    })
   }else if(props.steps == 2){
    setSteps({
        first: false,
        secund: true,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false

    })
   }else if(props.steps == 3){
    setSteps({
        first: false,
        secund: false,
        third: true,
        fourth: false,
        fifth: false,
        sixth: false

    })
   }else if(props.steps == 4){
    setSteps({
        first: false,
        secund: false,
        third: false,
        fourth: true,
        fifth: false,
        sixth: false

    })
   }else if(props.steps == 5){
    setSteps({
        first: false,
        secund: false,
        third: false,
        fourth: false,
        fifth: true,
        sixth: false

    })
   }else if(props.steps == 6){
    setSteps({
        first: false,
        secund: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: true

    })}


},
[props.steps])
    
  
  function nextPage(){

  }
 
    return <> 
  { !props.wrapNavigator? <div className="navBar_buy">
        <div className={steps.first?"navBar_buy_item choosen_item":"navBar_buy_item"}>{props.steps > 1?
                <svg width="13" height="24" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8565 0.827979C10.5646 0.837715 10.2881 0.960929 10.0857 1.1713C7.93795 3.32362 6.2976 5.12136 4.30447 7.15574L2.1811 5.3618V5.36192C1.95357 5.1695 1.6588 5.0755 1.36186 5.10077C1.06501 5.12604 0.790303 5.26849 0.598586 5.49649C0.406756 5.7246 0.313678 6.01959 0.339757 6.31644C0.365837 6.61329 0.508985 6.88753 0.737553 7.07877L3.65268 9.54545V9.54533C3.86723 9.72604 4.1416 9.81981 4.42175 9.8081C4.70202 9.79651 4.96767 9.68025 5.16636 9.48229C7.58147 7.06199 9.30069 5.12898 11.6695 2.75514V2.75526C11.8877 2.5443 12.0112 2.25393 12.0115 1.9505C12.012 1.64694 11.8894 1.35635 11.6717 1.14482C11.454 0.93328 11.1599 0.819006 10.8566 0.828146L10.8565 0.827979Z" fill="#CC0033"/>
                </svg>:""}
                <p>Uczestnik</p></div>
        <div className={steps.secund?"navBar_buy_item choosen_item":"navBar_buy_item"}>{props.steps > 2?
                <svg width="13" height="24" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8565 0.827979C10.5646 0.837715 10.2881 0.960929 10.0857 1.1713C7.93795 3.32362 6.2976 5.12136 4.30447 7.15574L2.1811 5.3618V5.36192C1.95357 5.1695 1.6588 5.0755 1.36186 5.10077C1.06501 5.12604 0.790303 5.26849 0.598586 5.49649C0.406756 5.7246 0.313678 6.01959 0.339757 6.31644C0.365837 6.61329 0.508985 6.88753 0.737553 7.07877L3.65268 9.54545V9.54533C3.86723 9.72604 4.1416 9.81981 4.42175 9.8081C4.70202 9.79651 4.96767 9.68025 5.16636 9.48229C7.58147 7.06199 9.30069 5.12898 11.6695 2.75514V2.75526C11.8877 2.5443 12.0112 2.25393 12.0115 1.9505C12.012 1.64694 11.8894 1.35635 11.6717 1.14482C11.454 0.93328 11.1599 0.819006 10.8566 0.828146L10.8565 0.827979Z" fill="#CC0033"/>
                </svg>:""}
                <p>Data rozpoczęcia</p></div>
        <div className={steps.third?"navBar_buy_item choosen_item":"navBar_buy_item"}>{props.steps > 3?
                <svg width="13" height="24" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8565 0.827979C10.5646 0.837715 10.2881 0.960929 10.0857 1.1713C7.93795 3.32362 6.2976 5.12136 4.30447 7.15574L2.1811 5.3618V5.36192C1.95357 5.1695 1.6588 5.0755 1.36186 5.10077C1.06501 5.12604 0.790303 5.26849 0.598586 5.49649C0.406756 5.7246 0.313678 6.01959 0.339757 6.31644C0.365837 6.61329 0.508985 6.88753 0.737553 7.07877L3.65268 9.54545V9.54533C3.86723 9.72604 4.1416 9.81981 4.42175 9.8081C4.70202 9.79651 4.96767 9.68025 5.16636 9.48229C7.58147 7.06199 9.30069 5.12898 11.6695 2.75514V2.75526C11.8877 2.5443 12.0112 2.25393 12.0115 1.9505C12.012 1.64694 11.8894 1.35635 11.6717 1.14482C11.454 0.93328 11.1599 0.819006 10.8566 0.828146L10.8565 0.827979Z" fill="#CC0033"/>
                </svg>:""}
                <p>Wariant cenowy</p></div>
        <div className={steps.fourth?"navBar_buy_item choosen_item":"navBar_buy_item"}>{props.steps > 4?
                <svg width="13" height="24" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8565 0.827979C10.5646 0.837715 10.2881 0.960929 10.0857 1.1713C7.93795 3.32362 6.2976 5.12136 4.30447 7.15574L2.1811 5.3618V5.36192C1.95357 5.1695 1.6588 5.0755 1.36186 5.10077C1.06501 5.12604 0.790303 5.26849 0.598586 5.49649C0.406756 5.7246 0.313678 6.01959 0.339757 6.31644C0.365837 6.61329 0.508985 6.88753 0.737553 7.07877L3.65268 9.54545V9.54533C3.86723 9.72604 4.1416 9.81981 4.42175 9.8081C4.70202 9.79651 4.96767 9.68025 5.16636 9.48229C7.58147 7.06199 9.30069 5.12898 11.6695 2.75514V2.75526C11.8877 2.5443 12.0112 2.25393 12.0115 1.9505C12.012 1.64694 11.8894 1.35635 11.6717 1.14482C11.454 0.93328 11.1599 0.819006 10.8566 0.828146L10.8565 0.827979Z" fill="#CC0033"/>
                </svg>:""}
                <p>Forma płatności i rabat</p></div>
        <div className={steps.fifth?"navBar_buy_item choosen_item":"navBar_buy_item"}>{props.steps > 5?
               <svg width="13" height="24" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M10.8565 0.827979C10.5646 0.837715 10.2881 0.960929 10.0857 1.1713C7.93795 3.32362 6.2976 5.12136 4.30447 7.15574L2.1811 5.3618V5.36192C1.95357 5.1695 1.6588 5.0755 1.36186 5.10077C1.06501 5.12604 0.790303 5.26849 0.598586 5.49649C0.406756 5.7246 0.313678 6.01959 0.339757 6.31644C0.365837 6.61329 0.508985 6.88753 0.737553 7.07877L3.65268 9.54545V9.54533C3.86723 9.72604 4.1416 9.81981 4.42175 9.8081C4.70202 9.79651 4.96767 9.68025 5.16636 9.48229C7.58147 7.06199 9.30069 5.12898 11.6695 2.75514V2.75526C11.8877 2.5443 12.0112 2.25393 12.0115 1.9505C12.012 1.64694 11.8894 1.35635 11.6717 1.14482C11.454 0.93328 11.1599 0.819006 10.8566 0.828146L10.8565 0.827979Z" fill="#CC0033"/>
               </svg>:""}
                <p>Raty</p></div>
        <div className={steps.sixth?"navBar_buy_item choosen_item":"navBar_buy_item"}>{props.steps > 6?
                <svg width="13" height="24" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8565 0.827979C10.5646 0.837715 10.2881 0.960929 10.0857 1.1713C7.93795 3.32362 6.2976 5.12136 4.30447 7.15574L2.1811 5.3618V5.36192C1.95357 5.1695 1.6588 5.0755 1.36186 5.10077C1.06501 5.12604 0.790303 5.26849 0.598586 5.49649C0.406756 5.7246 0.313678 6.01959 0.339757 6.31644C0.365837 6.61329 0.508985 6.88753 0.737553 7.07877L3.65268 9.54545V9.54533C3.86723 9.72604 4.1416 9.81981 4.42175 9.8081C4.70202 9.79651 4.96767 9.68025 5.16636 9.48229C7.58147 7.06199 9.30069 5.12898 11.6695 2.75514V2.75526C11.8877 2.5443 12.0112 2.25393 12.0115 1.9505C12.012 1.64694 11.8894 1.35635 11.6717 1.14482C11.454 0.93328 11.1599 0.819006 10.8566 0.828146L10.8565 0.827979Z" fill="#CC0033"/>
                </svg>:""}
                <p>Umowa</p></div>
    </div>:<div className="smallNavigator">
    {!steps["first"]?<svg onClick={props.clickForSmalButton} className="svgNav" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.823757 7.80559L6.05841 13.4629C6.4067 13.8393 7.00292 13.8356 7.34661 13.455C7.64902 13.1202 7.64627 12.61 7.34028 12.2784L3.2463 7.84173C2.89286 7.4587 2.89286 6.86844 3.2463 6.48542L7.34028 2.04878C7.64627 1.71717 7.64902 1.20699 7.34661 0.872108C7.00292 0.491506 6.4067 0.487889 6.05841 0.864294L0.823757 6.52156C0.494532 6.88625 0.49451 7.44092 0.823757 7.80559Z" fill="#CC0033"/>
    </svg>:""}

        <div className={!steps["first"]?!steps["sixth"]?'wrappedNAvigator':"lastNavigator":"firstwrappedNAvigator"}>
        <p className={steps["first"]?"current_navBar":"not_current"}>Krok 1/6: Uczestnik</p>
        <p className={steps["secund"]?"current_navBar":"not_current"}>Krok 2/6: Data rozpoczęcia</p>
        <p className={steps["third"]?"current_navBar":"not_current"}>Krok 3/6: Wariant cenowy</p>
        <p className={steps["fourth"]?"current_navBar":"not_current"}>Krok 4/6: Forma płatności i rabat</p>
        <p className={steps["fifth"]?"current_navBar":"not_current"}>Krok 5/6: Raty</p>
        <p className={steps["sixth"]?"current_navBar":"not_current"}>Krok 6/6: Umowa</p>
       </div>
       {!steps["sixth"]?<svg className={!steps["first"]?"svgNav":"firstSvgNav"} width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.66452 7.80559L2.42987 13.4629C2.08158 13.8393 1.48536 13.8356 1.14167 13.455C0.839266 13.1202 0.842012 12.61 1.148 12.2784L5.24198 7.84173C5.59542 7.4587 5.59542 6.86844 5.24198 6.48542L1.148 2.04878C0.842012 1.71717 0.839266 1.20699 1.14167 0.872108C1.48536 0.491506 2.08158 0.487889 2.42987 0.864294L7.66452 6.52156C7.99375 6.88625 7.99377 7.44092 7.66452 7.80559Z" fill="#CC0033"/>
        </svg>:""}

       </div>}  
    
    </>;
    }

export default NavigatorBar;
